export default function Seznam() {
	return (
		<div className='ribbon-seznam'>
			<a
				className='ribbon-seznam__link'
				href='https://www.seznam.cz'
				rel='noopener noreferrer'
				target='_blank'
				data-dot='lista_odkaz_seznam'
			>
				Seznam.cz
			</a>
		</div>
	);
}
